import api from "./Api";
import { PORTS } from "../config/modulePort";
import { PICKLIST_GROUP_NAME } from "../common/Constant";
const Acivity_Update = process.env.REACT_APP_CASE_URL || "";
const ActivityAPI = api(Acivity_Update);
// api/caseActions.ts
// Assuming ActivityAPI is an Axios instance like axios.create({ baseURL: ... })

export async function updateCaseStageAction(
  caseInfoId: number,
  actionType:
    | "OnHold"
    | "Resumed"
    | "Cancelled"
    | "Closed"
    | "Archived"
    | "Unarchived",
  reason: string
): Promise<any> {
  try {
    const response = await ActivityAPI.put(
      "api/case/activity/stage/update",
      {
        caseInfoId,
        actionType,
        reason,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Update case stage action failed:", error);
    throw error?.response?.data || error;
  }
}
